export default __webpack_public_path__ + "static/companyPresentation-e6b96c35d880bf9af5c47833b4b3483d.svg";